import styles from "./Containers.module.css";

const AuditPromptCard = ({ children }) => {
  return <div className={styles.auditPromptCard}>{children}</div>;
};

export default AuditPromptCard;
